// import { Map, fromJS } from 'immutable';
import { constantCreator } from '~/utils/constantsCreator';

import api from '~/utils/api';
import { isMultiTier, isMultiTierSupportForeignPrices } from '~/utils/payment';
import { decorateMultiTierPricesToQuantity } from '~/utils/trip';
import cloneDeep from 'lodash/cloneDeep';

const constant = constantCreator('trip');

const GET_TRIP = constant('GET_TRIP', true);
const GET_REVIEWS = constant('GET_REVIEWS', true);
const SYNC_UP_TRIP = constant('SYNC_UP_TRIP');
const CHANGE_TAB = constant('CHANGE_TAB');
const OPEN_VIDEO = constant('OPEN_VIDEO');
const CLOSE_VIDEO = constant('CLOSE_VIDEO');
const OPEN_SHARE = constant('OPEN_SHARE');

const LOG_VIEW_TRIP = constant('LOG_VIEW_TRIP');
const LOG_CLICK_SEE_MORE = constant('LOG_CLICK_SEE_MORE');
const LOG_CLICK_CARD = constant('LOG_CLICK_CARD');
const LOG_IMPRESS_CARD = constant('LOG_IMPRESS_CARD');
const LOG_IMPRESS_TOPIC = constant('LOG_IMPRESS_TOPIC');
const LOG_SCROLL_END = constant('LOG_SCROLL_END');
const LOG_IMPRESS_OLD_TRIP = constant('LOG_IMPRESS_OLD_TRIP');
const LOG_CLICK_OLD_TRIP = constant('LOG_CLICK_OLD_TRIP');
const LOG_CLICK_BOOK_NOW = constant('LOG_CLICK_BOOK_NOW');
const LOG_REQUEST = constant('LOG_REQUEST');
const LOG_MESSAGE_CAR_RENTAL = constant('LOG_MESSAGE_CAR_RENTAL');
const CHANGE_TIER = constant('CHANGE_TIER');
const CHANGE_MULT_TIER_QTY = constant('CHANGE_MULT_TIER_QTY');
const CUSTOMIZE_QTY = constant('CUSTOMIZE_QTY', true);
const REPLY_REVIEW = constant('REPLY_REVIEW', true);
const GET_TRIPS_PRICE = constant('GET_TRIPS_PRICE', true);
const VOTE_REVIEW = constant('VOTE_REVIEW', true);
const CHANGE_SELECTED_MULTI_TIER = constant('CHANGE_SELECTED_MULTI_TIER');
const CHANGE_NON_TRIP_QUANTITY = constant('CHANGE_NON_TRIP_QUANTITY');

const LOG_IMPRESS_SIMILAR_TRIPS_AB = constant('LOG_IMPRESS_SIMILAR_TRIPS_AB');
const LOG_IMPRESS_SIMILAR_TRIP_CARD = constant('LOG_IMPRESS_SIMILAR_TRIP_CARD');
const LOG_CLICK_SIMILAR_TRIP_CARD = constant('LOG_CLICK_SIMILAR_TRIP_CARD');

const LOG_COPY_FIRSTBOOKING_CODE = constant('LOG_COPY_FIRSTBOOKING_CODE');
const LOG_CLICK_COPY_PROMO = constant('LOG_CLICK_COPY_PROMO');

const VIEWED_TRIP = constant('VIEWED_TRIP', true);

const initialState = {
  loading: false,
  loaded: false,
  data: {},
  // data: {},
  nonTripQuantity: 1,
  selectedMultiTier: null,
  multiTierQuantity: [],
  foreignMultiTierQuantity: {},
  activeTier: null,
  url: '',
  isOpenVideo: false,
  isOpenShare: false,
  mobileTab: 'overview',
  error: {},
  isError: false,
  isRedirect: false,
  isLoadingPricing: false,
  pricing: {},
  reviews: [],
  isLoadingReview: true,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TRIP.PENDING:
      return {
        ...state,
        loading: true
      };
    case GET_TRIP.RESOLVED: {
      const foreignMultiTierQuantity = {};
      if (
        isMultiTier(action.data)
        && isMultiTierSupportForeignPrices(action.data)
      ) {
        Object.keys(action.data.foreign_multi_tier_prices).forEach(cur => {
          foreignMultiTierQuantity[cur] = decorateMultiTierPricesToQuantity(
            action.data.foreign_multi_tier_prices[cur]
          );
        });
      }
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.data.is_redirect ? {} : {
          ...state.data ? state.data : {},
          ...action.data,
          video_url: action.data.video_url, // this line fix 'video icon appear on other trips which have no video' bug,
          grouped_trips: action.data.grouped_trips,
        },
        // data: action.data.is_redirect ? {} : {
        //   ...state.data ? state.data : {},
        //   ...action.data,
        // },
        activeTier: null,
        isError: false,
        isRedirect: action.data.is_redirect,
        error: {},
        multiTierQuantity: isMultiTier(action.data)
          ? decorateMultiTierPricesToQuantity(action.data.multi_tier_prices)
          : [],
        foreignMultiTierQuantity,
      };
    }
    case GET_TRIP.REJECTED:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: {},
        // data: {},
        error: action.data,
        isError: true,
        isRedirect: false,
      };
    case GET_TRIPS_PRICE.PENDING:
      return {
        ...state,
        pricing: action.data,
        isLoadingPricing: true
      };
    case GET_TRIPS_PRICE.RESOLVED:
      return {
        ...state,
        pricing: action.data,
        isLoadingPricing: false
      };
    case GET_TRIPS_PRICE.REJECTED:
      return {
        ...state,
        pricing: action.data,
        isLoadingPricing: true
      };
    case SYNC_UP_TRIP:
      return {
        ...state,
        data: {
          ...state.data,
          _id: `${action.id.toString()}`,
          slug: action.slug,
        },
        id: action.id,
        slug: action.slug
      };
    case CHANGE_TAB:
      return {
        ...state,
        mobileTab: action.tab,
      };
    case OPEN_VIDEO:
      return {
        ...state,
        isOpenVideo: true,
        url: action.url,
      };
    case CLOSE_VIDEO:
      return {
        ...state,
        isOpenVideo: false,
        url: '',
      };
    case CHANGE_TIER: // eslint-disable-line
      const multiTierQuantity = cloneDeep(state.multiTierQuantity);
      const foreignMultiTierQuantity = cloneDeep(
        state.foreignMultiTierQuantity
      );
      Object.keys(foreignMultiTierQuantity).forEach(cur => {
        foreignMultiTierQuantity[cur] = decorateMultiTierPricesToQuantity(
          foreignMultiTierQuantity[cur]
        );
      });
      return {
        ...state,
        activeTier: action.activeTier,
        multiTierQuantity: decorateMultiTierPricesToQuantity(multiTierQuantity),
        foreignMultiTierQuantity,
      };
    case CHANGE_MULT_TIER_QTY: {
      return {
        ...state,
        multiTierQuantity: action.multiTierQuantity,
        foreignMultiTierQuantity: action.foreignMultiTierQuantity,
      };
    }
    case OPEN_SHARE:
      return {
        ...state,
        isOpenShare: action.open,
      };
    case CHANGE_SELECTED_MULTI_TIER:
      return {
        ...state,
        selectedMultiTier: action.selectedMultiTier,
      };
    case CHANGE_NON_TRIP_QUANTITY:
      return {
        ...state,
        nonTripQuantity: action.nonTripQuantity,
      };
    case GET_REVIEWS.PENDING:
    case GET_REVIEWS.REJECTED:
      return {
        ...state,
        isLoadingReview: true,
      };
    case GET_REVIEWS.RESOLVED:
      return {
        ...state,
        isLoadingReview: false,
        reviews: action.data,
      };
    default:
      return state;
  }
};

export default reducer;

export const actions = {
  getTripData: slug => ({
    type: GET_TRIP,
    // promise: api.get(`/trips/slug/${slug}?is_experience=true`),
    promise: api.get(`/trips/slug/${slug}?is_experience=true`),
    slug,
  }),
  viewedTrip: tripId => ({
    type: VIEWED_TRIP,
    promise: api.post('/session/view-trip', { trip_id: tripId }),
  }),
  getReviews: slug => ({
    type: GET_REVIEWS,
    promise: api.get(`/reviews/trip?slug=${slug}`),
  }),
  changeTab: tab => ({
    type: CHANGE_TAB,
    tab,
  }),
  openVideo: url => ({
    type: OPEN_VIDEO,
    url,
  }),
  closeVideo: () => ({
    type: CLOSE_VIDEO,
  }),
  logClickCard: data => ({
    type: LOG_CLICK_CARD,
    data,
  }),
  logImpressCard: data => ({
    type: LOG_IMPRESS_CARD,
    data,
  }),
  logImpressTopic: data => ({
    type: LOG_IMPRESS_TOPIC,
    data,
  }),
  logClickSeeMore: data => ({
    type: LOG_CLICK_SEE_MORE,
    data,
  }),
  logScrollEnd: data => ({
    type: LOG_SCROLL_END,
    data,
  }),
  logImpressOldTrip: (tripId, tripType = 'default') => ({
    type: LOG_IMPRESS_OLD_TRIP,
    tripId,
    tripType,
  }),
  logClickOldTrip: (tripId, tripType = 'default') => ({
    type: LOG_CLICK_OLD_TRIP,
    tripId,
    tripType,
  }),
  logImpressSimilarTripTopic: (tripId, newSimilarTrip = false) => ({
    type: LOG_IMPRESS_SIMILAR_TRIPS_AB,
    tripId,
    newSimilarTrip
  }),
  logImpressSimilarTrip: (tripId, newSimilarTrip = false) => ({
    type: LOG_IMPRESS_SIMILAR_TRIP_CARD,
    tripId,
    newSimilarTrip,
  }),
  logClickSimilarTrip: (tripId, newSimilarTrip = false) => ({
    type: LOG_CLICK_SIMILAR_TRIP_CARD,
    tripId,
    newSimilarTrip,
  }),
  logClickBookNow: tripId => ({
    type: LOG_CLICK_BOOK_NOW,
    tripId,
  }),
  logRequest: data => ({
    type: LOG_REQUEST,
    data,
  }),
  logMessageCarRental: data => ({
    type: LOG_MESSAGE_CAR_RENTAL,
    data,
  }),
  openShare: (open = true) => ({
    type: OPEN_SHARE,
    open,
  }),
  changeTier: activeTier => ({
    type: CHANGE_TIER,
    activeTier,
  }),
  logViewTrip: trip => ({
    type: LOG_VIEW_TRIP,
    data: {
      _id: trip._id, name: trip.name, slug: trip.slug, product_type: trip.product_type
    },
  }),
  logCopyFirstBookingCode: () => ({
    type: LOG_COPY_FIRSTBOOKING_CODE
  }),
  logClickCopyPromo: (data) => ({
    type: LOG_CLICK_COPY_PROMO,
    data
  }),
  customizeQty: data => ({
    type: CUSTOMIZE_QTY,
    promise: api.post('/customize/quantity', data),
  }),
  replyReview: (id, text) => ({
    type: REPLY_REVIEW,
    promise: api.post(`/reviews/${id}/reply`, { text }),
  }),
  changeMultiTierQuantity: (
    multiTierQuantity,
    foreignMultiTierQuantity = {}
  ) => ({
    type: CHANGE_MULT_TIER_QTY,
    multiTierQuantity,
    foreignMultiTierQuantity,
  }),
  syncUpTrip: trip => ({
    type: SYNC_UP_TRIP,
    id: trip._id,
    slug: trip.slug
  }),
  getTripPrice: data => ({
    type: GET_TRIPS_PRICE,
    promise: api.post('/trips/price', data),
    data
  }),
  voteReview: (tripId, reviewId, vote) => {
    return ({
      type: VOTE_REVIEW,
      promise: api.post(`/reviews/${reviewId}/helpful`, {
        vote,
        tripId,
      })
    });
  },
  changeSelectedMultiTier: selectedMultiTier => ({
    type: CHANGE_SELECTED_MULTI_TIER,
    selectedMultiTier,
  }),
  changeNonTripQuantity: nonTripQuantity => ({
    type: CHANGE_NON_TRIP_QUANTITY,
    nonTripQuantity,
  })
};
/* eslint-disable */
export const analytics = {
  [LOG_IMPRESS_CARD]: action => ({name: 'Impress Card', category: 'Experience Trip', data: action.data, providers: 'database'}),
  [LOG_CLICK_CARD]: action => ({name: 'Click Card', category: 'Experience Trip', data: action.data, providers: 'database'}),
  [LOG_IMPRESS_TOPIC]: action => ({name: 'Impress Topic', category: 'Experience Trip', data: action.data, providers: 'database'}),
  [LOG_CLICK_SEE_MORE]: action => ({name: 'Click See All', category: 'Experience Trip', data: action.data, providers: 'database'}),
  [LOG_SCROLL_END]: action => ({name: 'Scroll End', category: 'Experience Trip', data: action.data, providers: 'database'}),
  [LOG_IMPRESS_OLD_TRIP]: action => (action.tripType === 'similar_trip' ?
    {name: 'Impress Trip', category: 'Trip', data: { tripId: action.tripId }, providers: 'database'}
  :
    {name: 'Impress Trip', category: 'Trip', data: { tripId: action.tripId }, providers: 'database'}
    ),
  [LOG_CLICK_OLD_TRIP]: action => (action.tripType === 'similar_trip' ?
    {name: 'Click Similar Trip', category: 'Similar Trip', data: { tripId: action.tripId }, providers: 'database'}
  :
    {name: 'Click Trip', category: 'Trip', data: { tripId: action.tripId }, providers: 'database'}),
  [LOG_CLICK_BOOK_NOW]: action => ({name: 'Click Book Now', category: 'Trip', data: { tripId: action.tripId }, providers: 'database'}),
  [LOG_REQUEST]: (action) => ({name: 'Log Request', category: 'Payment', data: action.data}),
  [LOG_MESSAGE_CAR_RENTAL]: (action) => ({name: 'Log Message Car Rental', category: 'Payment', data: action.data}),
  [LOG_VIEW_TRIP]: action => ({name: 'View Trip', category: 'pageview', data: action.data, providers: 'database'}),
  [LOG_IMPRESS_SIMILAR_TRIPS_AB]: action =>
    ({
      name: `Impress Similar Trips Topic`,
      category: 'Similar Trip',
      data: { ...action.data, tripId: action.tripId },
      providers: 'database'
    }),
  [LOG_IMPRESS_SIMILAR_TRIP_CARD]: action =>
    ({
      name: `Impress Similar Trip Card`,
      category: 'Similar Trip',
      data: { ...action.data, tripId: action.tripId },
      providers: 'database'
    }),
  [LOG_CLICK_SIMILAR_TRIP_CARD]: action =>
    ({
      name: `Click Similar Trip Card`,
      category: 'Similar Trip',
      data: { ...action.data, tripId: action.tripId },
      providers: 'database'
    }),
  [LOG_COPY_FIRSTBOOKING_CODE]: () => ({
    name: 'Click copy FIRSTBOOKING code',
    category: 'FIRSTBOOKING promo',
    providers: 'database'
  }),
  [LOG_CLICK_COPY_PROMO]: (action) => ({
    name: 'Click Copy Promo',
    category: 'Web 5.0',
    data: action.data,
    providers: 'database'
  }),
};
/* eslint-enable */
